export class MessageResolver {
    constructor() {
        let raw = null;
        if (document.getElementById('app-config')) {
            raw = JSON.parse(document.getElementById('app-config').innerHTML);
        }
        this.data = null;

        if (raw && raw.core_pa) {
            this.data = raw.core_pa;
        }
    }

    getMessage(key) {
        if (this.data && this.data[key]) {
            return this.data[key];
        }

        return '';
    }
}
